module.exports = __webpack_public_path__ + "img/candDocs-download-icon.7bea7093.svg";